"use strict";

var _classCallCheck = require("C:\\Users\\James\\Documents\\Dev\\vet-nurse-guide\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\James\\Documents\\Dev\\vet-nurse-guide\\node_modules\\@babel\\runtime/helpers/createClass");

var cssstyle = require("cssstyle");

var ElementCSSInlineStyle =
/*#__PURE__*/
function () {
  function ElementCSSInlineStyle() {
    _classCallCheck(this, ElementCSSInlineStyle);
  }

  _createClass(ElementCSSInlineStyle, [{
    key: "_initElementCSSInlineStyle",
    value: function _initElementCSSInlineStyle() {
      var _this = this;

      this._style = new cssstyle.CSSStyleDeclaration(function (newCssText) {
        if (!_this._settingCssText) {
          _this._settingCssText = true;

          _this.setAttribute("style", newCssText);

          _this._settingCssText = false;
        }
      });
    }
  }, {
    key: "style",
    get: function get() {
      return this._style;
    },
    set: function set(value) {
      this._style.cssText = value;
    }
  }]);

  return ElementCSSInlineStyle;
}();

module.exports = {
  implementation: ElementCSSInlineStyle
};